<article>
  <div class="tabview-list">
    @if (isAdmin) {
      <div [class.active]="tabIndex() === 'org'" (click)="tabClick('org')"><i class="mdi mdi-wrench-outline"></i> Org</div>
    }
    <div [class.active]="tabIndex() === 'site'" (click)="tabClick('site')"><i class="mdi mdi-office-building-outline"></i> Site</div>
    <div [class.active]="tabIndex() === 'gateway'" (click)="tabClick('gateway')"><i class="mdi mdi-router-wireless"></i> Gateway</div>
    <div [class.active]="tabIndex() === 'asset'" (click)="tabClick('asset')"><i class="mdi mdi-view-list"></i> Asset</div>
    <div [class.active]="tabIndex() === 'user'" (click)="tabClick('user')"><i class="mdi mdi-account"></i> User</div>
    <div [class.active]="tabIndex() === 'help'" (click)="tabClick('help')"><i class="mdi mdi-info"></i> Help</div>
    <div></div>
  </div>
  <div class="tabview-content">
    @switch (tabIndex()) {
      @case ('org') {
        @if (dataTableOrgs) {
          <app-data-table [dataTable]="dataTableOrgs" (onRowClick)="rowClick('org', $event)" dataTableKey="entities:orgs"></app-data-table>
        } @else {
          <i class="fa fa-refresh fa-spin"></i>
        }
      }
      @case ('site') {
        @if (dataTableSites) {
          <app-data-table [dataTable]="dataTableSites" (onRowClick)="rowClick('site', $event)" dataTableKey="entities:sites"></app-data-table>
        } @else {
          @if (!sites) {
            <i class="fa fa-refresh fa-spin"></i>
          }
        }
      }
      @case ('gateway') {
        @if (dataTableGateways) {
          <app-data-table [dataTable]="dataTableGateways" (onRowClick)="rowClick('gateway', $event)" dataTableKey="entities:gateways"></app-data-table>
        } @else {
          <i class="fa fa-refresh fa-spin"></i>
        }
      }
      @case ('asset') {
        @if (dataTableAssets) {
          <app-data-table [dataTable]="dataTableAssets" (onRowClick)="rowClick('asset', $event)" dataTableKey="entities:assets"></app-data-table>
        } @else {
          <i class="fa fa-refresh fa-spin"></i>
        }
        <p>Or you can create a new issue direct from the Query graph "Issue Tracking" tab for the asset.</p>
      }
      @case ('user') {
        @if (dataTableUsers) {
          <app-data-table [dataTable]="dataTableUsers" (onRowClick)="rowClick('user', $event)" dataTableKey="entities:users"></app-data-table>
        } @else {
          <i class="fa fa-refresh fa-spin"></i>
        }
      }
      @default {
        <section class="content-container">
          <h3>Overview</h3>
          <div>This is purely optional, if you'd like to add links to help recall this issue in the future or for future reports on issues by site etc.</div>
          <h3>Checklist</h3>
          <div>The entities become checklist items that can be checked, as issues are resolved for example.</div>
          <h3>Usage</h3>
          <p>If the issue is an organisational issue, select an organisation.</p>
          <div>If the issue is an entire site, select a site, otherwise select the equipment.</div>
        </section>
      }
    }
  </div>
</article>
